// directive
const angularRequire = require('../../../common/bootstrap/angularRequire') // css loaded from cdn in index.html

var moduleName = 'clientDashboardApp.chatmeterAdmin.accountManagement';
var mod = angular.module(moduleName, [
  "clientDashboardApp.auth",
  angularRequire('ng-tags-input'),
  "clientDashboardApp.admin.users.editor"
])
  .config(function($stateProvider, $urlRouterProvider) {

  $urlRouterProvider.when('/chatmeterAdmin', 'chatmeterAdmin/billingAccounts');
  $stateProvider
    .state('chatmeterAccountAdmin', {
      url: '/chatmeterAdmin',
      template: '<ui-view />',
      isAbstract: true
    })
    .state('chatmeterAccountAdmin.billingAccounts', {
      url: '/billingAccounts?{pageSize:int}&billingType&sortField&{pageIndex:int}&q&tags&ignoreTags&{showActive:bool}&{sortDirection:int}&dateMode&startDate',
      template: require('./billingAccountsSummary.html'),
      controller: 'billingAccountsSummaryCtrl'
    })
    .state('chatmeterAccountAdmin.keywords', {
      url: '/keywords',
      template: require('../keywords/keywordManagement.html'),
      controller: 'KeywordManagmentController',
      controllerAs: 'vm'
    })
    .state('chatmeterAccountAdmin.verticals', {
      url: '/verticals',
      template: require('../verticals/verticalManagement.html'),
      controller: 'VerticalManagementController',
      controllerAs: 'vm'
    })
    .state('billing', {
      url: '/billing',
      template: '<ui-view />',
      isAbstract: true
    })
    .state('billing.invoiceList', {
      url: '/:authenticationKey/subscription/:subscriptionId/invoices',
      template: require('./invoiceList.html'),
      controller: 'InvoiceListCtrl'
    })
    .state('billing.invoice', {
      url: '/:authenticationKey/subscription/:subscriptionId/invoice/:invoiceId',
      template: require('./invoice.html'),
      controller: 'InvoiceCtrl'
    })

});

require('./billingAccountsSummaryCtrl').default(mod);
require('./billingAccountsService').default(mod);
require('./billingAccountEditorCtrl').default(mod);
require('./configEditorCtrl').default(mod);
require('./invoicingEditorCtrl').default(mod);
require('./invoiceListCtrl').default(mod);
require('./invoiceCtrl').default(mod);
require('./configEditorTabs/register').default(mod);
require('./adminUserInfoCtrl').default(mod);
require('../keywords/keywordManagement').default(mod);
require('../verticals/verticalManagement').default(mod);

module.exports = moduleName;
